// Texty zvýrazněných recenzí na detailu produktu (reviewHighlights.js, recenze U3):
// karta „Recenze zákazníků" pod galerií (A) a citát u názvu produktu (D).
import { plural } from '../plural.js';

export default {
  /** nadpis karty s vlastními recenzemi produktu */
  title: 'Recenze zákazníků',
  /** nadpis karty s hodnocením nákupu od kupujících (produkt bez vlastních recenzí) */
  buyersTitle: 'Zákazníci, kteří koupili tento produkt',
  /** podtitul karty kupujících, když produkt slovní recenze má (jen žádná nejde citovat) */
  buyersSub: 'Hodnotí nákup v našem obchodě.',
  /** podtitul karty kupujících u produktu bez jediné slovní recenze */
  buyersSubFirst: 'Hodnotí nákup v našem obchodě. Recenzi produktu zatím nikdo nenapsal.',
  /** nadpis karty s hodnocením obchodu (patro 3: produkt bez recenzí i bez hodnocení od kupujících) */
  shopTitle: (shop) => 'Hodnocení obchodu ' + shop,
  /** podtitul karty obchodu u produktu s hodnocením (hvězdičky nebo text, který se necituje) */
  shopSub: 'Hodnotí nákup v našem obchodě.',
  /** podtitul karty obchodu u produktu bez jediného hodnocení */
  shopSubFirst: 'Recenzi tohoto produktu zatím nikdo nenapsal.',
  /** „275 hodnocení" (číslo už formátované) */
  ratings: (n, count) => n + ' ' + plural(count, ['hodnocení', 'hodnocení', 'hodnocení']),
  /** „3 777 hodnocení obchodu" */
  shopRatings: (n, count) => n + ' ' + plural(count, ['hodnocení obchodu', 'hodnocení obchodu', 'hodnocení obchodu']),
  /** „88 % dává 4 a více hvězd" (pct = celé číslo) */
  share: (pct) => pct + '\u00A0% dává 4 a více hvězd',
  /** CTA karty: „Všech 104 recenzí" */
  allReviews: (n, count) => plural(count, ['Zobrazit recenzi', 'Všechny ' + n + ' recenze', 'Všech ' + n + ' recenzí']),
  /** CTA karty, když slovních recenzí víc není */
  allRatings: 'Všechna hodnocení',
  /** CTA karty kupujících: „Dalších 7 hodnocení od kupujících" */
  moreBuyers: (n, count) => plural(count, ['Další ' + n + ' hodnocení od kupujících', 'Další ' + n + ' hodnocení od kupujících', 'Dalších ' + n + ' hodnocení od kupujících']),
  /** CTA karty kupujících, když další hodnocení nejsou */
  allShopRatings: 'Všechna hodnocení obchodu',
  /** druhý odkaz karty kupujících u produktu bez slovní recenze */
  firstReview: 'Máte ho doma? Napište první recenzi',
  /** druhý odkaz karty kupujících u produktu jen s hvězdičkami bez textu */
  writeReview: 'Napište recenzi',
  /** odkaz na stránku o ověřování recenzí (§ 5a odst. 5 ZOS) */
  verify: 'Jak recenze ověřujeme',
  /** totéž v řádku pod pásem karet na mobilu */
  verifyShort: 'Jak ověřujeme',
  /** štítek recenze z dotazníku Heureky */
  sourceHeureka: 'Ověřeno Heurekou',
  /** štítek recenze napsané na webu („Recenze na Jipos.cz") */
  sourceWeb: (shop) => 'Recenze na ' + shop,
  /** štítek hodnocení nákupu od kupujícího (z dotazníku Heureky) */
  buyerHeureka: 'Koupil tento produkt · ověřeno Heurekou',
  /** štítek hodnocení nákupu od kupujícího (jiný zdroj) */
  buyer: 'Koupil tento produkt',
  /** štítek obecného hodnocení obchodu (patro 3 a výplň karty) z dotazníku Heureky */
  shopHeureka: 'Hodnocení obchodu · ověřeno Heurekou',
  /** štítek obecného hodnocení obchodu (jiný zdroj) */
  shopLabel: 'Hodnocení obchodu',
  /** citát D: tučná část „dalších 103" … */
  more: (n, count) => plural(count, ['další ' + n, 'další ' + n, 'dalších ' + n]),
  /** … a podstatné jméno za ní (na mobilu skryté) */
  moreNoun: (count) => plural(count, ['recenze', 'recenze', 'recenzí']),
  /** aria-label hvězd recenze */
  starsAria: (n) => n + ' z 5 hvězd',
};
